import { http,uploadFile } from './axios.js';

const Api = {
	url:'https://www.taiqiu123.com',
	
	//上传文件 营业执照 
	async upload_business_license(filePath) {
		return await uploadFile('/api/user/upload_business_license',filePath).then(res => res)
	},
	//上传文件 头像 
	async upload_head_pic(filePath) {
		return await uploadFile('/api/user/upload_head_pic',filePath).then(res => res)
	},
	//获取订单文件
	async get_worddown(data,sing) {
		return await http('/api/user/order_download',data, 'post',sing).then(res => res)
	},
	//注册 
	async register(data,sing) {
		return await http('/api/user/reg',data, 'post',sing).then(res => res)
	},
	//验证码  
	async reg_send(data,sing) {
		return await http('/api/user/reg_send',data, 'post',sing).then(res => res)
	},
	//验证码  
	async reg_send2(data,sing) {
		return await http('/api/user/reg_send_sms',data, 'post',sing).then(res => res)
	},
	  
	async test(data,sing) {
		return await http('/api/index/test',data, 'post',sing).then(res => res)
	},
	//使用条款
	async terms_of_use(data) {
		return await http('/api/user/terms_of_use',data, 'post').then(res => res)
	},
	//隐私政策
	async privacy_policy(data) {
		return await http('/api/user/privacy_policy',data, 'post').then(res => res)
	},
	//登录
	async login(data,sing) {
		return await http('/api/user/login',data, 'post',sing).then(res => res)
	},
	//登录
	async login_other(data,sing) {
		return await http('/api/user/third_login',data, 'post',sing).then(res => res)
	},
	//忘记密码  
	async forget_pwd(data,sing) {
		return await http('/api/user/forget_pwd',data, 'post',sing).then(res => res)
	},
	//忘记密码发送验证码 
	async forget_send(data,sing) {
		return await http('/api/user/forget_send',data, 'post',sing).then(res => res)
	},
	//首页 
	async index(data) {
		return await http('/api/index/index',data, 'post').then(res => res)
	},
	//新闻详情 
	async news_details(data,sing) {
		return await http('/api/index/news_details',data, 'post',sing).then(res => res)
	},
	//商品分类
	async gat_cat(data) {
		return await http('/api/goods/goods_cat_list',data, 'post').then(res => res)
	},
	//商品品牌
	async get_brand(data) {
		return await http('/api/goods/goods_brand_list',data, 'post').then(res => res)
	},
	//商品列表 
	async goods_list(data,sing) {
		return await http('/api/goods/goods_list',data, 'post',sing).then(res => res)
	},
	//商品详情 
	async goods_details(data,sing) {
		return await http('/api/goods/goods_details',data, 'post',sing).then(res => res)
	},
	//地址列表
	async address_list(data,sing) {
		return await http('/api/user/address_list',data, 'post',sing).then(res => res)
	},
	//地址添加 
	async address_add(data,sing) {
		return await http('/api/user/address_add',data, 'post',sing).then(res => res)
	},
	//地址编辑
	async address_edit(data,sing) {
		return await http('/api/user/address_edit',data, 'post',sing).then(res => res)
	},
	//地址删除
	async address_del(data,sing) {
		return await http('/api/user/address_del',data, 'post',sing).then(res => res)
	},
	//修改密码 
	async pwd_edit(data,sing) {
		return await http('/api/user/pwd_edit',data, 'post',sing).then(res => res)
	},
	//系统消息 
	async sys_msg_list(data,sing) {
		return await http('/api/user/sys_msg_list',data, 'post',sing).then(res => res)
	},
	//帮助中心 
	async help_list(data,sing) {
		return await http('/api/user/help_list',data, 'post',sing).then(res => res)
	},
	//资料修改 
	async user_edit(data,sing) {
		return await http('/api/user/user_edit',data, 'post',sing).then(res => res)
	},
	//获取个人资料 
	async get_user_info(data,sing) {
		return await http('/api/user/get_user_info',data, 'post',sing).then(res => res)
	},
	//订单列表 
	async order_list(data,sing) {
		return await http('/api/user/order_list',data, 'post',sing).then(res => res)
	},
	//确认订单
	async order_check(data,sing) {
		return await http('/api/goods/order_check',data, 'post',sing).then(res => res)
	},
	//下单 
	async order_do(data,sing) {
		return await http('/api/goods/order_do',data, 'post',sing).then(res => res)
	},
	//订单详情
	async order_details(data,sing) {
		return await http('/api/user/order_details',data, 'post',sing).then(res => res)
	},
	//取消订单 
	async order_cancel(data,sing) {
		return await http('/api/user/order_cancel',data, 'post',sing).then(res => res)
	},
	//订单收货 
	async order_confirm(data,sing) {
		return await http('/api/user/order_confirm',data, 'post',sing).then(res => res)
	},
	//联系我们 
	async contact_us(data,sing) {
		return await http('/api/index/contact_us',data, 'post',sing).then(res => res)
	},
	//获取信息 
	async web_info(data,sing) {
		return await http('/api/index/web_info',data, 'post',sing).then(res => res)
	},
	//获取订单信息
	async user_home(data,sing) {
		return await http('/api/user/home',data, 'post',sing).then(res => res)
	},
	//谷歌解码
	async google_account_decode(data,sing) {
		return await http('/api/user/google_account_decode',data, 'post',sing).then(res => res)
	},
	//发货记录详情数据
	async shippinglog_details(data,sing) {
		return await http('/api/user/shippinglog_details',data, 'post',sing).then(res => res)
	},
};


export default Api

